import React from 'react';
import './Select.css';

const Select = ({ label, name, value, onChange, options, error, required }) => {
  return (
    <div className="select-group">
      {label && <label htmlFor={name}>{label}</label>}
      <select
        id={name}
        name={name}
        value={value}
        onChange={onChange}
        required={required}
        className={error ? 'select-error' : ''}
      >
        {options.map(opt => (
          <option key={opt.value} value={opt.value}>{opt.label}</option>
        ))}
      </select>
      {error && <span className="error-message">{error}</span>}
    </div>
  );
};

export default Select;